import { TemplateRef } from '@angular/core';

export interface RRIFilterSettings {
  invalid: boolean;
  tooltip?: string;
  title: string;
  hideFilter?: boolean;
  filterClass?: string;
  type?: string;
  showFieldHasValue?: boolean;
  template?: TemplateRef<any>;
}
